import { SUBMENU_PARAM_KEY } from '../../../constants/route'
import { useQueryParamSubTab } from '../../../hooks'
import { TabList } from '../../Tab'

import { CALENDAR_SETTINGS_FORMS_FIXTURE_IDS } from './CalendarSettingsForms.constants'
import {
  getCalendarSettingsFormsFixtureContent,
  getCalendarSettingsFormsFixtures,
} from './CalendarSettingsForms.utils'

function CalendarSettingsForms() {
  const { activeSubTab, setActiveSubTab } = useQueryParamSubTab({
    allowedValues: CALENDAR_SETTINGS_FORMS_FIXTURE_IDS,
    paramKey: SUBMENU_PARAM_KEY,
  })

  return (
    <>
      <TabList
        activeTab={activeSubTab}
        getTabs={getCalendarSettingsFormsFixtures}
        onSetActiveTab={setActiveSubTab}
      />
      {getCalendarSettingsFormsFixtureContent(activeSubTab)}
    </>
  )
}

export default CalendarSettingsForms
